import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {computed, inject, watch, ref, Ref} from "vue";
import FileUploader from '@/components/FileUploader.vue';
import CSVConfigSelector from '@/components/CSVConfigSelector.vue';
import FileTable from '@/components/FileTable.vue';

import { key } from "@/components/FileManager";
import { toastInjectionKey } from "@/components/Toaster/ToastManager";
import { PlotData } from "@/components/Impedance";
import NyquistPlot from "@/components/NyquistPlot.vue";
import DRTPlot from "@/components/DRTPlot.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AboutView',
  setup(__props) {

const files = inject(key);
const toaster = inject(toastInjectionKey);

const data = computed(()=>{
  return files?.keys().map(key=>{
    const impedance = files.files[key].impedance;
    const drt = files.files[key].drt;
    let output = {} as PlotData;
    output.uuid = key;
    output.name = files.files[key].file.name;
    output.f = impedance.f;
    output.rs = impedance.rs;
    output.x = impedance.x;
    if(drt){
      output.f_calc = drt.calc_f;
      output.rs_calc = drt.calc_rs;
      output.x_calc = drt.calc_x;
    }
    return output;
  });
});

const drt_result:Ref<{[key:string]: any}> = ref({});

watch(data, ()=>{
  const keysToAnalyze = files?.keys().filter(key=> !(key in drt_result.value)).filter(key=>files?.files[key].impedance.f.length > 0);
  //とりあえずfをチェックすることでcsv parse前かどうかチェック

  //まず登録
  keysToAnalyze?.forEach(key=>{
    drt_result.value[key] = {};
  });

  keysToAnalyze?.forEach(key=>{
    const d = data.value?.find(d=>d.uuid === key);
    if(!d){
      return;
    }
    toaster?.info(d.name, "DRT calcultation started", 2000);
    fetch("https://33hiyo6b3j.execute-api.ap-northeast-1.amazonaws.com/v1/drt", {
        method: "post",
        mode: "cors",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
          input: JSON.stringify({
            method: "01",
            f: d.f,
            rs: d.rs,
            x: d.x,
            lambda: 0.1
          }),
          stateMachineArn: "arn:aws:states:ap-northeast-1:837132241748:stateMachine:DRTStateMachine"
        })
    }).then(r=>{
      return r.json();
    }).then(result=>{
      const execution_arn:string = result.executionArn;
      return new Promise((resolve2, reject2)=>{
          let retry = 0;
          const timer = setInterval(()=>{
              fetch("https://33hiyo6b3j.execute-api.ap-northeast-1.amazonaws.com/v1/drt/status", {
                  method: "POST",
                  mode: "cors",
                  headers: {
                      "Content-Type": "application/json"
                  },
                  body: JSON.stringify({
                      executionArn: execution_arn
                  })
              }).then(res=>{
                  retry += 1;
                  return res.json()
              }).then((result)=>{
                  if(retry > 30){
                      clearInterval(timer);
                      reject2();
                  }
                  if(result.status === "SUCCEEDED"){
                      clearInterval(timer);
                      resolve2(JSON.parse(result.output));
                  }
                  if(result.status === "FAILED"){
                      clearInterval(timer);
                      reject2(JSON.parse(result.output));
                  }
              }).catch(()=>{
                clearInterval(timer);
                console.log("!!!");
              });
          }, 10000);
      });
    }).then((result:any)=>{
      if(result["result"] != "OK"){
        toaster?.alert(d.name, "DRT calcultation failed", 2000);
        return;
      }
      toaster?.success(d.name, "DRT calcultation finished", 2000);
      drt_result.value[key] = result;

      if(files){
        files.files[key].drt = result;
      }
    }).catch(()=>{
      toaster?.alert(d.name, "DRT calcultation failed", 2000);
    })
  })

});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(FileUploader),
    _createVNode(CSVConfigSelector),
    _createVNode(FileTable),
    _createVNode(DRTPlot, { data: drt_result.value }, null, 8, ["data"]),
    _createVNode(NyquistPlot, { data: _unref(data) }, null, 8, ["data"])
  ], 64))
}
}

})